import { render, staticRenderFns } from "./McontactoGrid.vue?vue&type=template&id=31fd7d26"
import script from "./McontactoGrid.vue?vue&type=script&lang=js"
export * from "./McontactoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports